import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      data-testid="navigation"
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-[#fff8ed] border-b border-black/5 shadow-sm"
          : "bg-[#fff8ed]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("hero");
            }}
            data-testid="nav-logo"
            className="flex items-center"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_fragrance-network/artifacts/kj0kcj9m_Logo%20Le%20Pschitt%20Franc%CC%A7ais.jpeg"
              alt="Le Pschitt Français"
              className="h-16 md:h-20 w-auto object-contain rounded-md"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection("probleme")}
              data-testid="nav-probleme"
              className="font-body text-sm tracking-wide uppercase text-[#525252] hover:text-[#0A0A0A] transition-colors"
            >
              Défis
            </button>
            <button
              onClick={() => scrollToSection("solution")}
              data-testid="nav-solution"
              className="font-body text-sm tracking-wide uppercase text-[#525252] hover:text-[#0A0A0A] transition-colors"
            >
              Notre Solution
            </button>
            <button
              onClick={() => scrollToSection("tarifs")}
              data-testid="nav-tarifs"
              className="font-body text-sm tracking-wide uppercase text-[#525252] hover:text-[#0A0A0A] transition-colors"
            >
              Tarifs
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              data-testid="nav-cta-brochure"
              className="bg-[#0A0A0A] text-white hover:bg-[#B89F7C] transition-colors duration-300 px-6 py-3 text-sm tracking-widest uppercase font-medium"
            >
              Demander une brochure
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-black/5"
        >
          <div className="px-6 py-6 space-y-4">
            <button
              onClick={() => scrollToSection("probleme")}
              className="block w-full text-left font-body text-sm tracking-wide uppercase text-[#525252] hover:text-[#0A0A0A] py-2"
            >
              Défis
            </button>
            <button
              onClick={() => scrollToSection("solution")}
              className="block w-full text-left font-body text-sm tracking-wide uppercase text-[#525252] hover:text-[#0A0A0A] py-2"
            >
              Notre Solution
            </button>
            <button
              onClick={() => scrollToSection("tarifs")}
              className="block w-full text-left font-body text-sm tracking-wide uppercase text-[#525252] hover:text-[#0A0A0A] py-2"
            >
              Tarifs
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="w-full bg-[#0A0A0A] text-white hover:bg-[#B89F7C] transition-colors duration-300 px-6 py-3 text-sm tracking-widest uppercase font-medium"
            >
              Demander une brochure
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
